class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // If url has cart=1 open by default
    if (window.location.search.includes('cart=1')) {
      this.open();
    }

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      if(window.run_cart_version == "sidecart") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    cartLink.addEventListener('keydown', (event) => {
      if(window.run_cart_version == "sidecart") {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__container') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__container').classList.contains('is-empty') &&
      this.querySelector('.drawer__container').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__content',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


class DrawerApplyCode extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('submit', (event) => {
      event.preventDefault();

      var discount_code       = document.getElementById('discount-code-input').value.toUpperCase(),
          discount_error      = document.getElementById('code_error'),
          remove_code_loader  = this.querySelector('.removeCodeSpinner'),
          code_wrapper        = this.querySelector('.drawer_discount_wrapper form'),
          active_codes        = document.getElementById('discount_titles').value;

      function addCode(active_codes, discount_code) {
        const codes = active_codes
          .split(',')
          .map(code => code.trim())
          .filter(code => code.length > 0);
      
        if (!codes.includes(discount_code)) {
          codes.push(discount_code);
        }
      
        return codes.join(',');
      }

      var final_codes = addCode(active_codes, discount_code);
      
      if(discount_code.length == 0) discount_error.style.display = 'block';
      else {
        remove_code_loader.classList.toggle('hidden'),
        code_wrapper.classList.toggle('opaque'),
                    
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount: final_codes })
        })
        .then(response => response.json())
        .then(cart => {
            //Convert Experiments conversion tracking
            window._conv_q = window._conv_q || [];
            _conv_q.push(["triggerConversion", "1004100863"]);
            console.log('Convert: Promo code applied')
          
            let selectors = ['.cart__totals-rows', '.cart__items', '.cart__header', '.cart__shipping'];
            refreshShopifySection(`${routes.cart_url}`, selectors);
        });
      } 

      return;
           
    });
  }
}

customElements.define('drawer-apply-code', DrawerApplyCode);


class DrawerRemoveCode extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      var remove_code_loader  = this.querySelector('.removeCodeSpinner').classList.toggle('hidden');
      var code_wrapper        = this.closest('.drawer_discount_wrapper-copy').classList.toggle('opaque');
      var active_codes        = document.getElementById('discount_titles').value;
      var final_codes         = active_codes.split(',').filter(code => code.trim() !== this.dataset.code).join(',');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: final_codes })
      })
      .then(response => response.json())
      .then(cart => {
        let selectors = ['.cart__totals-rows', '.cart__items', '.cart__header', '.cart__shipping'];
        refreshShopifySection(`${routes.cart_url}`, selectors);
      });
      
    });
  }
}

customElements.define('drawer-remove-code', DrawerRemoveCode);

function refreshShopifySection(fetchUrl, refreshSelector) {
  fetch(fetchUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch: '+ fetchUrl);
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      for (const selector of refreshSelector) {
        const targetElement = document.querySelector(selector);
        const sourceElement = doc.querySelector(selector);
        if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
        else console.warn('Could not find target element for selector: '+ selector);
      }
      if(typeof mpx_msg == 'function') { // 2025-07-29
        mpx_msg(); console.log('%cmpx_msg-1','background:orange')
      }
    })
    .catch(error => {
      console.error('Error refreshing section:', error);
    });
}